import {CheatPlugin} from '../../CheatModuleInterfaces';
import {CheatReelsSetMatrixView} from './CheatReelsSetMatrixView';
import {CheatReelsSetMatrixController} from './CheatReelsSetMatrixController';

const reelsSetMatrix: CheatPlugin = {
    name: 'Reels Set Matrix',
    init: () => [
        CheatReelsSetMatrixController,
        CheatReelsSetMatrixView
    ]
};

export default reelsSetMatrix;
